import { useContent } from "../context/ContentContext";
import { resolveAsset } from "../lib/api";

export const Galeria = () => {
  const { content } = useContent();
  const gallery = content.gallery || [];
  if (!gallery.length) return null;
  return (
    <section id="galeria" data-testid="galeria-section" className="section-anchor bg-[#081A4D]/60 backdrop-blur-[2px] py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#8AB0FF] mb-4">Galería</p>
        <h2 className="font-serif-display text-3xl sm:text-4xl font-semibold text-white mb-12">Momentos</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 lg:gap-6">
          {gallery.map((url, i) => (
            <img
              key={i}
              data-testid={`gallery-photo-${i}`}
              src={resolveAsset(url)}
              alt={`Galería ${i + 1}`}
              loading="lazy"
              className="w-full h-48 md:h-56 object-cover rounded-xl border border-[#C0C7D1]/40"
            />
          ))}
        </div>
      </div>
    </section>
  );
};
